import React from 'react';
import CompanyRegistrationWizard from '../../components/company/CompanyRegistrationWizard';

const CompanyRegistration = () => {
    return (
        <div className="flex align-items-center justify-content-center" style={{
            background: '#f8fafc',
            minHeight: '100vh',
            width: '100vw',
            padding: '1rem 0',
            overflowY: 'auto'
        }}>
            <CompanyRegistrationWizard />
        </div>
    );
};

export default CompanyRegistration;
